import { useState } from 'react'
import { getTenantPortalAbsoluteUrl } from '@/config/tenant'
import { useSaveFeedback } from '@/hooks/useSaveFeedback'
import styles from './TenantPortalLinks.module.css'

type Props = {
  slug: string
  nome?: string
  compact?: boolean
}

export function TenantPortalLinks({ slug, nome, compact = false }: Props) {
  const url = getTenantPortalAbsoluteUrl(slug)
  const { notifySaved, notifyInfo } = useSaveFeedback()
  const [copied, setCopied] = useState<'app' | null>(null)

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url)
      setCopied('app')
      notifySaved('Link copiado.')
      setTimeout(() => setCopied(null), 2000)
    } catch {
      notifyInfo('Copie manualmente o link abaixo.')
    }
  }

  const whatsappText = encodeURIComponent(
    `Olá! Este é o link da app${nome ? ` de ${nome}` : ''}:\n${url}\n\nAbra no telemóvel ou computador. No painel de gestão, escolha «Painel administrador» e use o e-mail e senha que definimos.`
  )

  return (
    <div className={`${styles.box} ${compact ? styles.boxCompact : ''}`}>
      <p className={styles.label}>Link da app (enviar ao cliente)</p>
      <div className={styles.row}>
        <code className={styles.url}>{url}</code>
        <button type="button" className={styles.btn} onClick={copy}>
          {copied === 'app' ? 'Copiado' : 'Copiar'}
        </button>
        <a href={url} target="_blank" rel="noopener noreferrer" className={styles.btnOutline}>
          Abrir
        </a>
      </div>
      <div className={styles.secondary}>
        <a
          href={`https://wa.me/?text=${whatsappText}`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.waLink}
        >
          Partilhar modelo WhatsApp
        </a>
      </div>
      <p className={styles.hint}>
        O cliente abre este link e vê o ecrã de login habitual (entrar, criar conta, admin e profissional) — sem
        digitar código de conta.
      </p>
    </div>
  )
}
